module.exports = __webpack_public_path__ + "assets/img/18_169.6c66d12d.jpg";